// components/AppointmentComponent.jsx

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image'; // Assuming you are using Next.js
import Button from "@/Components/Common/Buttons/Buttons";
import { calculateDurationInReadableFormat, convertTimeTo24HourWithDateFormat, convertToMonthAndDayWithDateFormat } from "../../../utils/common";
import socketService from "../../../utils/socket";
import useAppointments from "../../../reactQuery/appointment";
import { useDispatch } from "react-redux";
import CancleDoctorMeeting from "../../DoctorsDashboard/DoctorsMeeting/CancleDoctorMeeting";
import RescheduleAppointments from "../../DoctorsDashboard/DoctorsMeeting/RescheduleAppointments";
import ApproveMeeting from "../../DoctorsDashboard/DoctorsMeeting/ApproveMeeting";
import BookAppointments from "../../DoctorsDashboard/Reps/BookAppointments/BookAppointments";
import { useCancelRequestedAppointmentMutation } from "../../../Redux/apis/appointments";
import CancelRequestedMeeting from "../../DoctorsDashboard/DoctorsMeeting/CancelRequestedMeeting";
import { toast } from 'react-toastify';
import { IoChevronDown } from "react-icons/io5";
import { MdSchedule } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { MdPending } from "react-icons/md";
const AppointmentComponent = ({
  appointmentToSchedule = null,
  setAppointmentToSchedule = null,
  isBookAppointmentToScheduleOpen = false,
  setIsBookAppointmentToScheduleOpen = null,
  updateParams,
  message,
  appointment,
  users,
  activeChat
}) => {
  const dispatch = useDispatch();
  const [selectedAppointment, setSelectedAppointment] = useState({});
  const [selectedRequestedAppointment, setSelectedRequestedAppointment] = useState({});
  const [isCancelMeetingOpen, setIsCancelMeeting] = useState(false);
  const [isCancelRequestedMeetingOpen, setIsCancelRequestedMeeting] = useState(false);
  const [isBookAppointmentOpen, setIsBookAppointmentOpen] = useState(false);
  const [hasCalledSocket, setHasCalledSocket] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRescheduleMeetingOpen, setIsRescheduleMeetingOpen] = useState(false);
  const [isApproveMeetingOpen, setIsApproveMeetingOpen] = useState(false);
  const {
    cancelAppointment,
    approveAppointment
  } = useAppointments();
  const [cancelRequestedAppointment, cancelRequestedAppointmentResponse] = useCancelRequestedAppointmentMutation();
  const closeBookAppointmentPopup = () => {
    if (setAppointmentToSchedule) setAppointmentToSchedule(null);
    if (setIsBookAppointmentToScheduleOpen) setIsBookAppointmentToScheduleOpen(false);
    if (updateParams) updateParams();
    setIsBookAppointmentOpen(false);
  };
  const openCancelMeeting = appointment_0 => {
    setSelectedAppointment(appointment_0);
    setIsCancelMeeting(true);
  };
  const closeCancelMeeting = () => {
    if (updateParams) updateParams();
    setIsCancelMeeting(false);
  };
  const openCancelRequestedMeeting = appointment_1 => {
    setSelectedRequestedAppointment(appointment_1);
    setIsCancelRequestedMeeting(true);
  };
  const closeCancelRequestedMeeting = () => {
    if (updateParams) updateParams();
    setIsCancelRequestedMeeting(false);
  };
  const cancelSelectedAppointment = () => {
    setHasCalledSocket(false);
    cancelAppointment.mutate(selectedAppointment._id);
  };
  useEffect(() => {
    if (cancelAppointment?.isLoading) {
      setLoading(true);
    } else if (!cancelAppointment?.isLoading && cancelAppointment?.isSuccess && cancelAppointment?.data && !hasCalledSocket) {
      socketService.cancelMetingByUser({
        receiverId: activeChat?.id,
        senderId: users?._id,
        profilePic: users?.profile,
        appointmentId: selectedAppointment?._id,
        senderName: users?.firstName + " " + users.lastName
      });
      setHasCalledSocket(true);
      closeCancelMeeting();
      setLoading(false);
      cancelAppointment.reset();
    } else if (cancelAppointment?.isError && cancelAppointment?.status === "rejected" && cancelAppointment?.error?.status === 400) {
      setLoading(false);
      toast.error(cancelAppointment?.error?.data?.message);
    }
  }, [cancelAppointment]);
  const cancelSelectedRequestedAppointment = () => {
    setHasCalledSocket(false);
    cancelRequestedAppointment(selectedRequestedAppointment._id);
  };
  useEffect(() => {
    if (cancelRequestedAppointmentResponse?.isLoading) {
      setLoading(true);
    } else if (!cancelRequestedAppointmentResponse?.isLoading && cancelRequestedAppointmentResponse?.isSuccess && cancelRequestedAppointmentResponse?.data && !hasCalledSocket) {
      socketService.cancelRequestedMeeting({
        receiverId: activeChat?.id,
        senderId: users?._id,
        profilePic: users?.profile,
        requestedAppointmentId: selectedRequestedAppointment?._id,
        senderName: users?.firstName + " " + users.lastName,
        reason: selectedRequestedAppointment?.reason
      });
      setHasCalledSocket(true);
      closeCancelRequestedMeeting();
      setLoading(false);
      cancelRequestedAppointmentResponse.reset();
    } else if (cancelRequestedAppointmentResponse?.isError && cancelRequestedAppointmentResponse?.status === "rejected" && cancelRequestedAppointmentResponse?.error?.status === 400) {
      setLoading(false);
      toast.error(cancelRequestedAppointmentResponse?.error?.data?.message);
    }
  }, [cancelRequestedAppointmentResponse]);
  const openRescheduleMeeting = appointment_2 => {
    setHasCalledSocket(false);
    setSelectedAppointment(appointment_2);
    setIsRescheduleMeetingOpen(true);
  };
  const closeReschedulelMeeting = () => {
    if (updateParams) updateParams();
    setIsRescheduleMeetingOpen(false);
  };
  const [isMeetingDetailDropDownOpen, setMeetingDetailDropDownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleOpenDropdown = () => {
    setMeetingDetailDropDownOpen(!isMeetingDetailDropDownOpen);
  };
  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setMeetingDetailDropDownOpen(false);
    }
  };
  useEffect(() => {
    if (isMeetingDetailDropDownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // return () => {
    //     document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, [isMeetingDetailDropDownOpen]);
  const confirmMeeting = appointment_3 => {
    setHasCalledSocket(false);
    try {
      setLoading(true);
      approveAppointment.mutate(selectedAppointment._id);
    } catch (e) {
      setLoading(false);
      toast.error("Appointment update failed!");
    }
  };
  const openApprovalMeeting = appointment_4 => {
    setHasCalledSocket(false);
    setSelectedAppointment(appointment_4);
    setIsApproveMeetingOpen(true);
  };
  const closeApproveMeeting = () => {
    if (updateParams) updateParams();
    setIsApproveMeetingOpen(false);
  };
  useEffect(() => {
    if (approveAppointment?.isLoading) {
      setLoading(true);
    } else if (!approveAppointment?.isLoading && approveAppointment?.isSuccess && approveAppointment?.data && !hasCalledSocket) {
      let appointmentData = approveAppointment?.data?.slot;
      socketService.confirmMetingByUser({
        receiverId: activeChat?.id,
        senderId: users?._id,
        profilePic: users?.profile,
        appointmentId: appointmentData?._id,
        senderName: users?.firstName + " " + users.lastName
      });
      setHasCalledSocket(true);
      closeApproveMeeting();
      setLoading(false);
      approveAppointment.reset();
    } else if (approveAppointment?.isError && approveAppointment?.status === "rejected" && approveAppointment?.error?.status === 400) {
      setLoading(false);
      toast.error(approveAppointment?.error?.data?.message);
    }
  }, [approveAppointment]);
  const cancelAppointmentDivs = () => {
    return <div className="w-full flex flex-col bg-white border border-[#F64C4C] bg-[#F64C4C0A] rounded-lg p-2.5 sm:p-3">
            <div className="text-[#4B4B4B] font-medium font-poppins text-[12px] sm:text-[14px]">
                {message?.senderId !== users?._id ? <>Your meeting with <span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> is canceled.</> : <>Your meeting with <span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> is canceled.</>}

            </div>

            <div className="w-full space-y-1.5 sm:space-y-2 pt-2 flex flex-col">
                <div className="flex items-start gap-1.5 sm:gap-2">
                    <div className="flex-shrink-0 w-4 sm:w-5 mt-0.5">
                        <Image src={"/Images/decription.svg"} height={16} width={16} alt="Decription" />
                    </div>
                    <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                        Description:
                    </div>
                    <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B] break-words">
                        {message?.appointmentId?.reason || " -"}
                    </div>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2">
                    <div className="flex-shrink-0 w-4 sm:w-5">
                        <Image src={"/Images/stopwatch.svg"} height={16} width={16} alt="stopwatch" />
                    </div>
                    <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                        Duration:
                    </div>
                    <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                        {calculateDurationInReadableFormat(message?.appointmentId?.startTime, message?.appointmentId?.endTime)}
                    </div>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2">
                    <div className="flex-shrink-0 w-4 sm:w-5">
                        <Image src={"/Images/Day.svg"} height={16} width={16} alt="stopwatch" />
                    </div>
                    <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                        Date:
                    </div>
                    <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                        {message?.appointmentId?.date && convertToMonthAndDayWithDateFormat(message?.appointmentId?.date)}
                    </div>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2">
                    <div className="flex-shrink-0 w-4 sm:w-5">
                        <Image src={"/Images/Time.svg"} height={16} width={16} alt="stopwatch" />
                    </div>
                    <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                        Time:
                    </div>
                    <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                        {message?.appointmentId?.startTime && convertTimeTo24HourWithDateFormat(message?.appointmentId?.startTime)}{" "}
                        -{" "}
                        {message?.appointmentId?.endTime && convertTimeTo24HourWithDateFormat(message?.appointmentId?.endTime)}
                    </div>
                </div>
            </div>
        </div>;
  };
  const requestedMetingDivs = () => {
    return <div className={`bg-[#FDFDFD] ${message?.requestedAppointmentId?.isCancelled ? 'border border-[#F64C4C]' : ''} w-full p-3 sm:p-4 rounded-lg border`}>
            {message?.requestedAppointmentId?.isCancelled ? <h3 className="text-[12px] sm:text-[14px] font-poppins leading-tight text-[#4B4B4B] font-semibold">
                    {message?.senderId !== users?._id ? <>Your meeting with <span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> is canceled.</> : <>Your meeting with <span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> is canceled.</>}
                </h3> : <h3 className="text-[12px] sm:text-[14px] font-poppins leading-tight text-[#4B4B4B] font-semibold">
                    {message?.senderId !== users?._id ? <><span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> is
                            requesting to schedule a meeting with you.
                        </> : <>You have requested a meeting with <span className=" font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}.</span></>}
                </h3>}
            <div className="text-[11px] sm:text-[12px] font-normal font-poppins mt-3 sm:mt-5 text-[#4B4B4B]">
                Reason:
            </div>
            <div className="text-[11px] sm:text-[12px] font-normal text-[#4B4B4B] font-poppins break-words">
                {message?.requestedAppointmentId?.reason}
            </div>
            {!message?.requestedAppointmentId?.isCancelled && !message?.requestedAppointmentId?.isScheduled && users?.type !== 'reps' && <div className="flex justify-between items-center gap-2 mt-3 sm:mt-4 w-full">
                    <div onClick={() => openCancelRequestedMeeting(message?.requestedAppointmentId)} className="flex-1 border hover:shadow-md rounded-lg flex justify-center items-center border-[#354EF0]">
                        <button className="text-[11px] sm:text-[12px] font-medium py-1.5 mx-auto text-center font-poppins text-[#354EF0]">
                            Reject
                        </button>
                    </div>
                    <div onClick={() => setIsBookAppointmentOpen(true)} className="flex-1 relative border hover:shadow-md rounded-lg flex justify-center items-center bg-[#354EF0]">
                        <button className="text-[11px] sm:text-[12px] flex justify-center items-center gap-1 sm:gap-2 font-medium py-1.5 text-center mx-auto font-poppins text-white">
                            Schedule
                        </button>
                    </div>
                </div>}
        </div>;
  };
  return <>
            {message?.requestedAppointmentId && requestedMetingDivs()}
            {message?.appointmentId && message?.appointmentId?.isBooked && message?.appointmentId?.isCancelled && cancelAppointmentDivs()}

            {message?.appointmentId && !message?.appointmentId?.isCancelled && <div className="w-full flex flex-col bg-white border border-[#EEEEEE] rounded-lg p-2.5 sm:p-3">
                    <div className="text-[#4B4B4B] font-medium font-poppins text-[12px] sm:text-[14px]">
                        {message?.senderId !== users?._id ? <span>
                                <span className="font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span> scheduled a meeting with you.
                            </span> : <span>
                                You have scheduled a meeting with <span className="font-poppins font-bold">{activeChat?.firstName} {activeChat?.lastName}</span>.
                            </span>}
                    </div>

                    <div className="w-full space-y-1.5 sm:space-y-2 pt-2 flex flex-col">
                        <div className="flex items-start gap-1.5 sm:gap-2">
                            <div className="flex-shrink-0 w-4 sm:w-5 mt-0.5">
                                <Image src={"/Images/decription.svg"} height={16} width={16} alt="stopwatch" />
                            </div>
                            <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                                Description:
                            </div>
                            <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B] break-words">
                                {appointment?.reason || " -"}
                            </div>
                        </div>

                        <div className="flex items-center gap-1.5 sm:gap-2">
                            <div className="flex-shrink-0 w-4 sm:w-5">
                                <Image src={"/Images/stopwatch.svg"} height={16} width={16} alt="stopwatch" />
                            </div>
                            <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                                Duration:
                            </div>
                            <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                                {appointment?.startTime && appointment?.endTime && calculateDurationInReadableFormat(appointment?.startTime, appointment?.endTime)}
                            </div>
                        </div>

                        <div className="flex items-center gap-1.5 sm:gap-2">
                            <div className="flex-shrink-0 w-4 sm:w-5">
                                <Image src={"/Images/Day.svg"} height={16} width={16} alt="stopwatch" />
                            </div>
                            <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                                Date:
                            </div>
                            <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                                {appointment?.date && convertToMonthAndDayWithDateFormat(appointment?.startTime)}
                            </div>
                        </div>
                        <div className="flex items-center gap-1.5 sm:gap-2">
                            <div className="flex-shrink-0 w-4 sm:w-5">
                                <Image src={"/Images/Time.svg"} height={16} width={16} alt="stopwatch" />
                            </div>
                            <div className="flex-shrink-0 text-[11px] sm:text-[12px] font-poppins font-normal text-[#4B4B4B]">
                                Time:
                            </div>
                            <div className="flex-1 min-w-0 text-[11px] sm:text-[12px] font-poppins font-medium text-[#4B4B4B]">
                                {appointment?.startTime && convertTimeTo24HourWithDateFormat(appointment?.startTime)} - {appointment?.endTime && convertTimeTo24HourWithDateFormat(appointment?.endTime)}
                            </div>
                        </div>
                    </div>

                    <div className="flex pt-3 sm:pt-5 justify-between gap-2 sm:gap-4 items-center w-full">
                        <div className="flex-1">
                            <Button textColor={"#354EF0"} fontSize={"12px"} padding={"5px 0px"} border={"1px solid #354EF0"} fontWeight={500} onClick={() => openCancelMeeting(appointment)}>
                                Cancel Meeting
                            </Button>
                        </div>


                        {appointment?.isRescheduled && !appointment?.rescheduleApproved && appointment?.rescheduledBy !== users.type || !message?.appointmentId?.isApproved && message?.appointmentId?.appointmentCreatedBy !== users?.type || !appointment?.isApproved || !appointment?.rescheduleApproved && appointment?.isRescheduled ? <div ref={dropdownRef} onClick={() => handleOpenDropdown()} className="flex-1 relative border hover:shadow-md rounded-lg flex justify-center items-center bg-[#354EF0]">
                                <button className="text-[11px] sm:text-[12px] flex justify-center items-center gap-1 sm:gap-2 font-medium py-1.5 text-center mx-auto font-poppins text-white">
                                    Actions{" "}
                                    <IoChevronDown size={12} className={`transition-transform ${isMeetingDetailDropDownOpen ? 'rotate-180' : ''}`} />
                                </button>
                                {isMeetingDetailDropDownOpen && <div
          // style={{bottom: '-77px'}}
          className="bg-white shadow-lg w-[160px] sm:w-full min-w-[150px] z-50 absolute right-0 bottom-full mb-1 border border-[#cecccc] rounded-lg">
                                        <div onClick={() => openRescheduleMeeting(appointment)} className="text-[12px] w-full text-black px-2 hover:bg-gray-100 flex cursor-pointer items-center gap-1.5 font-medium font-inter py-2 border-b">
                                            <MdSchedule size={16} color="#131523" />
                                            Re-schedule
                                        </div>

                                        {(appointment?.isRescheduled && !appointment?.rescheduleApproved && appointment?.rescheduledBy !== users.type || !message?.appointmentId?.isApproved && message?.appointmentId?.appointmentCreatedBy !== users?.type) && <div onClick={() => openApprovalMeeting(appointment)} className="text-[12px] w-full text-black px-2 hover:bg-gray-100 cursor-pointer flex items-center gap-1.5 font-medium font-inter py-2">
                                                    <FaCheck size={14} color="#131523" />
                                                    Approve
                                                </div>}

                                        {(!message?.appointmentId?.isApproved || !message?.appointmentId?.rescheduleApproved) && message?.appointmentId?.appointmentCreatedBy === users?.type && <div className="text-[12px] w-full text-black flex cursor-pointer hover:bg-gray-100 px-2 items-center gap-1.5 font-medium font-inter py-2">
                                                <MdPending size={16} color="#131523" />
                                                Pending Approval
                                            </div>}
                                    </div>}
                            </div> : <div className="flex-1">
                                <Button textColor={"white"} disabled={loading} fontSize={"12px"} padding={"6px 0px"} backgroundColor={"#354EF0"} fontWeight={500} onClick={() => openRescheduleMeeting(appointment)}>
                                    Reschedule
                                </Button>
                            </div>}

                    </div>
                </div>}

            {isCancelMeetingOpen && <CancleDoctorMeeting cancelSelectedAppointment={cancelSelectedAppointment} onClose={closeCancelMeeting} />}

            {isCancelRequestedMeetingOpen && <CancelRequestedMeeting cancelSelectedAppointment={cancelSelectedRequestedAppointment} onClose={closeCancelRequestedMeeting} />}
            {isRescheduleMeetingOpen && <RescheduleAppointments appointment={selectedAppointment} repData={selectedAppointment.repId} onClose={closeReschedulelMeeting} />}

            {isApproveMeetingOpen && <ApproveMeeting cancelSelectedAppointment={confirmMeeting} isLoading={approveAppointment.isPending} onClose={closeApproveMeeting} />}

            {isBookAppointmentOpen && <BookAppointments requestedAppointmentIdData={message?.requestedAppointmentId} reason={message?.requestedAppointmentId?.reason} repData={message?.requestedAppointmentId?.repId} onClose={closeBookAppointmentPopup} />}
            {appointmentToSchedule?._id === message._id && isBookAppointmentToScheduleOpen && appointmentToSchedule && <BookAppointments requestedAppointmentIdData={appointmentToSchedule?.requestedAppointmentId} reason={appointmentToSchedule?.requestedAppointmentId?.reason} repData={appointmentToSchedule?.requestedAppointmentId?.repId} onClose={closeBookAppointmentPopup} />}

        </>;
};
export default AppointmentComponent;